import {useSelector} from "react-redux";
import {Dropdown, Icon} from "semantic-ui-react";
import {RootState} from "../../app/store";
import {Link, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useAppDispatch} from "../../app/hooks";
import {Logout, RequestPassChange} from "../Auth/AuthActions";
import {LanguageSelector} from "./LanguageSelector";

export const ProfileMenu = () => {
  const {email, role} = useSelector((state: RootState) => state.auth);
  const {t} = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const handleChangePassword = () => {
    dispatch(RequestPassChange(email));
  };
  const handleLogout = () => {
    dispatch(Logout());
    navigate("/");
  }
  return (
    <Dropdown button className="icon header-btn" direction="left" floating labeled text={t("user_profile")} icon="user circle outline" basic compact>
      <Dropdown.Menu>
        <Dropdown.Header>{email}</Dropdown.Header>
        <Dropdown.Divider />
        <HeaderLink to="/">
          <Dropdown.Item>
            <Icon name="object ungroup outline" /> {t("dashboard")}
          </Dropdown.Item>
        </HeaderLink>
        {(role === "admin" || role === "super_admin") && 
          <HeaderLink to="/company-data">
            <Dropdown.Item>
              <Icon name="table" /> {t("company_data")}
            </Dropdown.Item>
          </HeaderLink>
        }
        <HeaderLink to="/user-manual">
          <Dropdown.Item>
            <Icon name="info circle" /> {t("user_manual")}
          </Dropdown.Item>
        </HeaderLink>
        <Dropdown.Item onClick={handleChangePassword}>
          <Icon name="key" /> {t("change_pass_btn")}
        </Dropdown.Item>
        <Dropdown.Item onClick={handleLogout}>
          <Icon name="sign out" /> {t("logout")}
        </Dropdown.Item>
        <LanguageSelector />
      </Dropdown.Menu>
    </Dropdown>
  );
};

const HeaderLink = ({to, children}: {to: string; children: React.ReactNode}) => (
  <Link to={to} className="header-link">
    {children}
  </Link>
);
